<section id="schedaPartner" class="content-padding darker">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="customerForm" (ngSubmit)="onSubmit()" *ngIf="customerForm">

            <div class="expert-personal-info">
                <fieldset>
                  <legend>PERSONAL INFORMATION:</legend>
                    <div class="col-48 grid-element" formGroupName="user">
                        <label>Cognome{{ customerForm.get('user').get("surname") | required }}</label>
                        <input type="text" name="surname" formControlName="surname">
                        <app-error-html-handler [ctrl]="customerForm.get('user').get('surname')" [messages]="formValidationMsgs.user.surname"></app-error-html-handler>
                    </div>
        
                    <div class="col-48 grid-element" formGroupName="user">
                        <label>Nome{{ customerForm.get('user').get("name") | required }}</label>
                        <input type="text" name="name" formControlName="name">
                        <app-error-html-handler [ctrl]="customerForm.get('user').get('name')" [messages]="formValidationMsgs.user.name"></app-error-html-handler>
                    </div>

                    <div class="col-48 grid-element">
                        <label>Data nascita{{ customerForm.get("dob") | required }}</label>
                        <input type="date" formControlName="dob" [max]="today">
                        <app-error-html-handler [ctrl]="customerForm.get('dob')" [messages]="formValidationMsgs.dob"></app-error-html-handler>
                    </div>

                    
                    <div class="col-48 grid-element">
                        <label>Citofono{{ customerForm.get("intercom") | required }}</label>
                        <input type="text" formControlName="intercom">
                        <app-error-html-handler [ctrl]="customerForm.get('intercom')" [messages]="formValidationMsgs.intercom"></app-error-html-handler>
                    </div>
        
                    
                    <div class="col-48 grid-element" formGroupName="user">
                        <label for="emailExpert">E-mail{{ customerForm.get('user').get('email') | required }}</label>
                        <input type="email" name="email" formControlName="email">
                        <app-error-html-handler [ctrl]="customerForm.get('user').get('email')" [messages]="formValidationMsgs.user.email"></app-error-html-handler>
                    </div>
                   
        
                    <div class="col-48 grid-element">
                        <label for="telefonoExpert">Numero di telefono{{ customerForm.get("phone") | required }}</label>
                        <input type="text" name="phone" formControlName="phone">
                        <app-error-html-handler [ctrl]="customerForm.get('phone')" [messages]="formValidationMsgs.phone"></app-error-html-handler>
                    </div>
        
                    <div class="grid-element-full">
                        <label for="indirizzoExpert">
                        Indirizzo standard{{ customerForm.get("address") | required }}
                        <span class="directions" (click)="directions($event)"><i class="fas fa-directions"></i></span>
                        </label>
                        <app-google-maps-search (setAddress)="getAddress($event)" addressType="geocode" [control]="customerForm.get('address')"></app-google-maps-search>
                        <app-error-html-handler [ctrl]="customerForm.get('address')" [messages]="formValidationMsgs.address"></app-error-html-handler>
                    </div>
                </fieldset>
                <br class="clear">
            </div>

            <div class="expert-personal-info">
                <fieldset>
                    <legend>DOCUMENTAZIONE E NOTE:</legend>
                    <div class="grid-element-full">
                        <label for="noteExpert">Note{{ customerForm.get("notes") | required }}</label>
                        <textarea formControlName="notes" rows="5" placeholder="Scrivi una nota"></textarea>
                    </div>
                </fieldset>
                <br class="clear">
            </div>

            <!--
            <div class="vehicle-and-notes" *ngIf="profile">
                <fieldset>
                    <legend>Password:</legend>
                    <div class="col-48 grid-element" formGroupName="user" *ngIf="profile">
                        <label>Password</label>
                        <input type="password" name="password1" formControlName="password1">
                        <app-error-html-handler [ctrl]="customerForm.get('user').get('password1')" [messages]="formValidationMsgs.user.password1"> </app-error-html-handler>
                    </div>
                    <div class="col-48 grid-element" formGroupName="user" *ngIf="profile">
                        <label>Ripeti password</label>
                        <input type="password" name="password2" formControlName="password2">
                        <app-error-html-handler [ctrl]="customerForm.get('user').get('password2')"[messages]="formValidationMsgs.user.password2"></app-error-html-handler>
                    </div>
                </fieldset>
            </div>
            -->

            <div class="center mt-20">
                <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!customerForm?.valid || tmpBtnDisabled" >
                  Salva<i class="ml-10 far fa-save"></i>
                </button>
            </div>

        </form>
        <br class="clear">
    </div>
</section>